module.exports = __webpack_public_path__ + "img/mind_template_item_3_4.95fa9946.png";